import React, { useEffect, useState } from "react";
import '../../assets/css/ProfilePlayer.css';
import playerImage from '../../assets/images/defaultPlayerImage.png';
import playersmallImage from '../../assets/images/PlayerImage.png';
import { FiEdit } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import AcountPopUp from "../../components/AccountPopUp";
import { useSelector } from "react-redux";
import { apiHandler } from "../../assets/api";
import { endpoint } from "../../assets/api/endpoint";
import { saveProfileData, saveProfileDetail } from '../../redux/UserDataSlice';
import { useDispatch } from 'react-redux';
import Layout from "../../layouts/Layout";
import Spinner from "../../components/Spinner";
import EditProfile from "../edit-profile/EditProfile";
import ContactUs from "../profile/ContactUs";
import YourSports from "../profile/YourSports";
import NotificationSettings from "../profile/NotificationSetting";
import ChooseLanguage from "../profile/ChooseLanguage";
import MembershipDetail from "../profile/MemberShipDetail";
import PaymentHistory from "../profile/PaymentHistory";
import CustomModal from "../../components/CustomModal";
import dummyImage from '../../assets/images/dummy-banner.jpg';
import PlayersList from "../profile/PlayerList";
import LogoutModal from "../../components/LogOutModal";
import DeleteYourAccount from "../profile/DeleteYourAccount";
import { HashLoader } from "react-spinners";
import MinorPrivacy from "../profile/MinorPrivacy";
import Boy from '../../assets/icons/B.png';
import Girl from '../../assets/icons/G.png';
import { CgProfile } from "react-icons/cg";
import { IoSettingsOutline } from "react-icons/io5";
import { MdOutlineCardMembership } from "react-icons/md";
import { FiPhone } from "react-icons/fi";
import { MdDeleteForever } from "react-icons/md";
import { RiPhoneLine } from "react-icons/ri";
import { IoGameControllerOutline } from "react-icons/io5";
import { FiUser } from "react-icons/fi";

const ProfilePlayer = () => {
  const [profileData, setProfileData] = useState(null);
  const [openSubmenu, setOpenSubmenu] = useState(null);
  const navigate = useNavigate();
  const { accessToken, userId, minorAccountList } = useSelector((state) => state.loginInfo);
  const dispatch = useDispatch();
  const sport = [
    { id: 1, sportName: 'Tennis' },
    { id: 2, sportName: 'Pickball' }
  ]
  const [selectedMenu, setSelectedMenu] = useState("player-profile");
  const [yourSportsData, setYourSportsData] = useState();
  const [yourSports, setyourSports] = useState();
  const [deletetAccount, setDeleteAccount] = useState()
  const toggleSubmenu = (index) => {
    setOpenSubmenu(prevIndex => prevIndex === index ? null : index);
  };

  const onEdit = () => navigate("./edit-profile");
  const goToNotificationPage = () => navigate("./notification");
  const goToLanguagePage = () => navigate("./language");
  const onGoToMembershipDetail = () => navigate('./membership-detail');
  const onGoToPaymentHistory = () => navigate('./payment-history');
  const onGoToContactUs = () => navigate('./contact-us');
  const handleCancel = () => navigate('./delete-your-account');
  const [deleteAccountModal, setDeleteAccountModal] = useState(false);
  const [playerGameProfileId, setPlayerGameProfileId] = useState();
  const [selectedSubmenu, setSelectedSubmenu] = useState("");
  const [stringerChecked, setStringerChecked] = useState(false);
  const [progressDeleteAccount, setProgressDeleteAccount] = useState();


  useEffect(() => {
    const fetchProfileData = async () => {
      try {
        const result = await apiHandler({
          url: `${endpoint.PLAYER_PROFILE}?id=${userId}`,
          method: "GET",
          authToken: accessToken?.accessToken,
        });

        setProfileData(result.data);
        dispatch(saveProfileData(result?.data));
      } catch (error) {
        console.error("Error fetching profile data:", error);
      }
    };

    const fetchSportData = async () => {
      try {
        const result = await apiHandler({
          url: `${endpoint.SPORT_FETCH}`,
          method: "GET",
          authToken: accessToken?.accessToken,
        });
      } catch (error) {
        console.error("Error fetching profile data:", error);
      }
    };


    if (userId && accessToken?.accessToken) {
      fetchProfileData();
      fetchSportData()
    }

  }, [userId, accessToken, stringerChecked]);


  const dummyImages = [
    dummyImage,
    dummyImage,
    dummyImage,
    dummyImage,
  ];
  const imagesToShow = profileData?.baseProfile?.images.image.length > 0
    ? profileData?.baseProfile?.images.image
    : dummyImages;
  useEffect(() => {
    if (imagesToShow.length > 0) {
      const timeout = setTimeout(() => {
        const carouselEl = document.querySelector('#carouselExampleSlidesOnly');
        if (carouselEl && window.bootstrap?.Carousel) {
          const existingInstance = window.bootstrap.Carousel.getInstance(carouselEl);
          if (existingInstance) {
            existingInstance.dispose(); // Dispose previous instance
          }
          new window.bootstrap.Carousel(carouselEl, {
            interval: 4000,
            ride: 'carousel',
          });
        }
      }, 100); // Slight delay to allow DOM to update

      return () => clearTimeout(timeout); // Cleanup
    }
  }, [imagesToShow]);



  const onStringer = async (isChecked) => {
    try {
      const result = await apiHandler({
        url: `${endpoint.STRINGER_OR_NOT}?action=${isChecked}`,
        method: "POST",
        authToken: accessToken?.accessToken,
      });
      if (result.data.message) {
        setStringerChecked(!stringerChecked)
      }
    } catch (error) {
      console.error("Error fetching profile data:", error);
    }
  };

  if (!profileData) {
    return <div className="d-flex justify-content-center align-items-center">
      <div className="d-flex align-items-center justify-content-center" style={{ height: '75vh' }}>
        < HashLoader color="#e48181" />
      </div>
    </div>;
  }
  const { baseProfile, userProfileResponse } = profileData;

  const onYourSports = (data) => {
    setYourSportsData(data);
    setSelectedMenu("your-sport");
    setSelectedSubmenu(data.sportName);
  };

  const onPlayerList = (gameId) => {
    navigate('./players-list', { state: { playerGameProfileId: gameId } });
    setSelectedMenu('playerlist')
    setPlayerGameProfileId(gameId)
  }
  const onDeleteAccount = () => {
    setDeleteAccountModal(true);
  };

  const handleCancelDelete = () => {
    setDeleteAccountModal(!deleteAccountModal);
  };

  const onSelectedMenu = (selectMenu) => {
    setSelectedMenu(selectMenu)
  }
  const onSetMenuItem = (selectMenu) => {
    setSelectedMenu(selectMenu)
  }
  const handleMenuClick = (menuKey) => {
    setSelectedMenu(menuKey);
    setSelectedSubmenu("");
  };

  const handleProgressDeleteAccount = () => {
    navigate('/delete-your-account')
  }

  return (

    <div className="container mt-sm-3" >
      <div className="row  menu-profile-section" >
        {/* Menu Section */}
        <div className="col-lg-3 col-sm-12   " >
          <div className="menu-section-content">
            <div className="menu-section" style={{ background: 'white' }}>
              <ul className="menu-list">
                <li
                  className={`menu-item ${selectedMenu === "player-profile" ? "active" : ""}`}
                  onClick={() => handleMenuClick("player-profile")}
                >
                  <span> <FiUser className="icon-font"/> Your Profile</span>
                </li>

                <li className="menu-item">
                  <div
                    onClick={() => toggleSubmenu(0)}
                    style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer' }}
                  >
                    <span> <IoGameControllerOutline className="icon-font"/> Your Sports</span>
                    <i className={`arrow-icon ${openSubmenu === 0 ? "open" : ""}`} />
                  </div>
                  {openSubmenu === 0 && (
                    <ul className="submenu-list">
                      {sport.map((sport, index) => (
                        <li
                          className={`submenu-item ${selectedMenu === "your-sport" && selectedSubmenu === sport.sportName ? "active" : ""}`}
                          key={index}
                          onClick={() => onYourSports({ sportName: sport.sportName, gameProfileId: sport.id, userProfileResponse })}
                        >
                          <span>{sport.sportName}</span>
                        </li>
                      ))}
                    </ul>
                  )}
                </li>

                { minorAccountList &&
                  <li className="menu-item">
                    <div
                      onClick={() => toggleSubmenu(1)}
                      style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer' }}
                    >
                      <span> <IoSettingsOutline className="icon-font"/> Settings</span>
                      <i className={`arrow-icon ${openSubmenu === 1 ? "open" : ""}`} />
                    </div>
                    {openSubmenu === 1 && (
                      <ul className="submenu-list">
                        <li
                          className={`submenu-item ${selectedMenu === "minor-privacy" ? "active" : ""}`}
                          onClick={() => handleMenuClick("minor-privacy")}
                        >
                          <span>Minor Privacy</span>
                        </li>
                      </ul>
                    )}
                  </li>}


                  <li className={`menu-item ${selectedMenu === "membership" ? "active" : ""}`} onClick={() => handleMenuClick("membership")}>
                    <span> <MdOutlineCardMembership className="icon-font"/>  Membership Details</span>
                  </li>

                <li
                  className={`menu-item ${selectedMenu === "contact" ? "active" : ""}`}
                  onClick={() => handleMenuClick("contact")}
                >
                  <span> <RiPhoneLine className="icon-font"/> Contact Us</span>
                </li>

                <li className="menu-item " onClick={onDeleteAccount}>
                  <span> < MdDeleteForever className="icon-font" /> Delete your account?</span>
                </li>
              </ul>

              <AcountPopUp handleLogout={handleCancelDelete} handleCancel={handleCancelDelete} />
            </div>
          </div>
        </div>
        <div className="col-lg-9 col-sm-12 profile-section-content ">
          {selectedMenu === "player-profile" &&
            <div className="player-profile-img-container" style={{ height: '100%' }}>
              <div className="w-100">
                <div style={{ height: '200px' }}>
                  <div id="carouselExampleSlidesOnly" className="carousel slide " data-bs-ride="carousel" data-bs-interval="1000" >
                    <div className="carousel-inner">
                      {imagesToShow?.map((imgSrc, index) => (
                        <div key={index} className={`carousel-item ${index === 0 ? 'active' : ''}`}>
                          <img
                            style={{ height: '400px' }}
                            src={
                              imgSrc.startsWith('blob:')
                                ? imgSrc
                                : `${endpoint.BASE_URL_STAGING}/public/images/${imgSrc}`
                            }
                            className="d-block w-100"
                            alt={`slide-${index}`}
                            onError={(e) => {
                              e.target.onerror = null;
                              e.target.src = dummyImage;
                            }}
                          />
                        </div>
                      ))}
                    </div>

                  </div>
                </div>
                <div className="profile-content-wrapper-container p-4 " >
                  <div className="d-flex justify-content-between align-items-center" >
                    <div className="d-flex">
                      <img
                        src={baseProfile?.avatarUrl}
                        width='79px' height='79px'
                        alt="Avatar"
                        className=" mb-2 profile-player-image"
                      />
                      <div style={{ height: '79px', width: '15px', backgroundColor: '#e9ecef', borderRadius: '0px', overflow: 'hidden' }}>
                        <div
                          style={{
                            height: `${baseProfile?.reliabilityNum}%`,
                            width: '100%',
                            backgroundColor: 'green',
                            transition: 'height 0.3s ease',
                          }}
                        ></div>
                      </div>
                    </div>
                    <div><FiEdit style={{ cursor: 'pointer', fontSize: '35px' }} onClick={onEdit} /></div>
                  </div>
                  <div className="d-flex align-items-center">
                    <h4 className="pe-2">{baseProfile?.name}</h4>
                    <div>
                      {baseProfile?.age ? `(${baseProfile.age})` : ''} {baseProfile?.gender || ''}{"  " }
                      <img src={ baseProfile?.gender == "MALE" ? Boy : Girl} width = '20px' height = '20px'/>
                    </div>
                  </div>
                  <h6 style={{ color: '#71727A' }}>@{baseProfile?.avatarName}</h6>
                  <p style={{ color: '#71727A' }}>{baseProfile?.note}</p>
                  <div className="row">
                    <div className="col-lg-6">
                      <p style={{ color: '#71727A' }}><strong>Fav Court:</strong> {baseProfile?.preferrableCourt}</p>
                      <p style={{ color: '#71727A' }}><strong>Skill Level:</strong> None</p>
                    </div>
                    <div className="col-lg-6">
                      <p style={{ color: '#71727A' }}><strong>Reliability :</strong> {baseProfile?.reliabilityNum
                      }</p>

                      <p style={{ color: '#71727A' }}><strong>Preferable Time:</strong> {baseProfile?.preferredTime || "None"}</p>
                    </div>
                  </div>
                  <div>
                    <label className="form-check-label">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        defaultChecked={!!baseProfile?.stringer}
                        onChange={(e) => onStringer(e.target.checked)}
                      />{" "}
                      I am providing request stringer service
                    </label>

                  </div>
                </div>
              </div>
            </div>
          }
          {selectedMenu === "contact" && <ContactUs />}
          {selectedMenu === "your-sport" && <YourSports yourSportsData={yourSportsData} onPlayerList={onPlayerList} onSelectedMenu={onSelectedMenu} />}
          {selectedMenu === "notification" && <NotificationSettings />}
          {selectedMenu === "minor-privacy" && <MinorPrivacy />}
          {selectedMenu === "language" && <ChooseLanguage />}
          {selectedMenu === "membership" && <MembershipDetail />}
          {selectedMenu === "payment" && <PaymentHistory />}
          <LogoutModal
            show={deleteAccountModal}
            onConfirm={handleProgressDeleteAccount}
            onCancel={handleCancelDelete}
            text={'Are you sure you want to delete your account?'}
          />
        </div>
      </div>
    </div>

  );
};

export default ProfilePlayer;
